module.exports = __webpack_public_path__ + "static/media/ex-profile.87c911d2.jpg";